import { useState, ReactNode } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { APP_VERSION, BUILD_DATE, COPYRIGHT_YEAR, COMPANY_NAME } from '../../../config/version';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 dark:bg-gray-900 dark:text-gray-100 flex flex-col">
      {/* Sticky h-12 app bar (3rem) — the sidebar's sticky top-12 offset below depends on it */}
      <Header onMenuClick={() => setSidebarOpen(true)} />
      <div className="flex flex-1">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="min-w-0 flex-1 px-4 pt-4 pb-6 sm:px-6 lg:px-8 lg:pt-5">
          {children}
        </main>
      </div>
      <footer className="bg-white border-t border-gray-200 py-4 px-6 dark:bg-gray-800 dark:border-gray-700">
        <div className="flex flex-col sm:flex-row items-center justify-between text-xs text-gray-500 dark:text-gray-400 gap-2">
          <p>&copy; {COPYRIGHT_YEAR} {COMPANY_NAME}. All rights reserved.</p>
          <p>Version {APP_VERSION} &middot; {BUILD_DATE}</p>
        </div>
      </footer>
    </div>
  );
}
